<template>
  <v-chip
    :class="{clickable: !disabled}"
    :disabled="disabled"
    color="transparent"
    :text-color="disabled ? 'grey' : 'msr'"
    class="ml-0 unselectable"
    data-cy="overlay-data-chip"
    small
    @click.native="disabled ? null : $emit('click')"
  >
    <v-avatar class="mr-0">
      <v-icon
        :color="disabled ? 'grey lighten-1' : 'msr'"
        small
      >
        edit
      </v-icon>
    </v-avatar>
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: function () {
        return this.$t('editDynamicOverlayFields');
      },
    },
  },
};
</script>

<style scoped>
.clickable >>> .v-chip__content:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataChip.vue